export const ADD_NEW_DOMAIN_REQUEST: any = 'ADD_NEW_DOMAIN_REQUEST'
export const ADD_NEW_DOMAIN_SUCCESS = 'ADD_NEW_DOMAIN_SUCCESS'
export const ADD_NEW_DOMAIN_FAILED = 'ADD_NEW_DOMAIN_FAILED'

export const GET_DOMAIN_LIST_REQUEST: any = 'GET_DOMAIN_LIST_REQUEST'
export const GET_DOMAIN_LIST_SUCCESS = 'GET_DOMAIN_LIST_SUCCESS'
export const GET_DOMAIN_LIST_FAILED = 'GET_DOMAIN_LIST_FAILED'


export const AddNewDomainAction = (data: any) => {
    return {
        type: ADD_NEW_DOMAIN_REQUEST,
        newDomain: data
    }
}

export const GetDomainListAction = () => {
    return {
        type: GET_DOMAIN_LIST_REQUEST,
    }
}